import Courses from './Courses';

export default Courses;
export * from './Courses';
